export const useStyles = theme => ({
  tabHead: {
    display: 'flex',
    msFlexWrap: 'nowrap',
    flexWrap: 'nowrap',
    paddingBottom: '1rem',
    marginTop: '-1px',
    overflowX: 'auto',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    WebkitOverflowScrolling: 'touch',
    '& li': {
      listStyle: 'none',
      flex: '1 0 auto',
      textAlign: 'center',
      fontFamily: 'acumin-pro-wide',
      fontWeight: '400',
      fontSize: '16px',
      padding: '20px 10px',
      borderRadius: '0px 0px 10px 10px',
      border: '1px solid #96969659',
      color: '#000000',
      cursor: 'pointer',
      [theme.breakpoints.down('xs')]: {
        padding: '10px 10px',
        marginRight: '-1px',
      },
    },
  },
  tabContainer: {
    width: '100%',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  activeTab: {
    fontWeight: '500 !important',
    // backgroundColor: '#156433ad',
    // color: '#fff !important',
    cursor: 'default',
  },
});
